export enum Path {
  Root = '/',
  AllBusinesses = '/businesses',
  Business = '/business',
}
